module.exports = __webpack_public_path__ + "img/stick_activites_canoe_kayak.95aaf46d.svg";